import moment from 'moment';

angular.module('magpieSecurity', [
  'ui.bootstrap',
  'magpieUtil'
]).
directive('magpieCustomer', function() {
  return {
    restrict: 'E',
    scope: {
      customer: '=?',
      description: '=?'
    },
    templateUrl: 'components/magpie-display/security/customer.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.customer = $scope.description.customer;
        $scope.organizations = $scope.description.organizations;
      }
    }
  };
}).
directive('magpieOrganization', function() {
  return {
    restrict: 'E',
    scope: {
      organization: '=?',
      description: '=?',
      userPermissions: '=?'
    },
    templateUrl: 'components/magpie-display/security/organization.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.organization = $scope.description.organization;
        $scope.defaultRepository = $scope.description.defaultRepository;
        $scope.permissions = $scope.description.permissions;
        if ($scope.organization) {
          $scope.clusterLimits = $scope.organization.clusterLimits;
        }
        $scope.userPermissions = $scope.description.userPermissions;
      }
    }
  };
}).
directive('magpieUser', function() {
  return {
    restrict: 'E',
    scope: {
      user: '@?',
      description: '@?'
    },
    templateUrl: 'components/magpie-display/security/user.html',
    controller: function($scope) {
      if ($scope.description) {
        const description = JSON.parse($scope.description);
        $scope.user = description.user;
        $scope.roles = description.roles;
        $scope.permissions = description.permissions;
        $scope.inheritedPermissions = description.inheritedPermissions;
      } else if ($scope.user) {
        $scope.user = JSON.parse($scope.user);
        $scope.roles = $scope.user.roles;
        $scope.permissions = $scope.user.permissions;
      }
    }
  };
}).
directive('magpieRole', function() {
  return {
    restrict: 'E',
    scope: {
      role: '=?',
      permissions: '=?',
      users: '=?',
      description: '=?'
    },
    templateUrl: 'components/magpie-display/security/role.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.role = $scope.description.role;
        $scope.users = $scope.description.users;
        $scope.permissions = $scope.description.permissions;
      }
    }
  };
}).
directive('magpiePermissions', function() {
  return {
    restrict: 'E',
    scope: {
      permissions: '=',
      inheritedPermissions: '=?'
    },
    templateUrl: 'components/magpie-display/security/permissions.html'
  };
}).
directive('magpieActivityHistory', function() {
  return {
    restrict: 'E',
    scope: {
      label: '@',
      activityHistory: '=',
      timestamp: '@?'
    },
    templateUrl: 'components/magpie-display/security/activity-history.html'
  };
}).
directive('magpieActivityHistoryDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/security/activity-history-details.html'
  };
}).
directive('magpieActivityHistoryRecord', function() {
  return {
    restrict: 'AE',
    scope: {
      record: '=',
      timestamp: '='
    },
    templateUrl: 'components/magpie-display/security/activity-history-record.html',
    controller: function($scope, $element, $timeout, $controller) {
      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
        $scope: $scope,
        $element: $element,
        $timeout: $timeout
      }));

      _.defaults($scope.record, {
        timestamp: moment($scope.timestamp)
      });
    }
  };
}).
directive('magpieUsageEvent', function() {
  return {
    restrict: 'AE',
    scope: {
      event: '='
    },
    templateUrl: 'components/magpie-display/security/usage-event.html',
    controller: function($scope) {
      $scope.getObjectType = function(event) {
        switch (event.eventType) {
          case 'Metadata':
            return event.objectType;
          default:
            return event.eventType;
        }
      };

      $scope.getPermissionType = function(event) {
        switch (event.eventType) {
          case 'GlobalRole':
            return event.role;
          case 'Result':
            return 'Read';
          default:
            return event.permissionType;
        }
      };

      $scope.getState = function(event) {
        if (_.isUndefined(event.isSuccess) || event.isSuccess) {
          return 'Succeeded';
        } else {
          return 'Failed';
        }
      };

      $scope.getObjectReference = function(event) {
        const names = [
          event.dataSourceName,
          event.schemaName,
          event.projectName,
          event.structureName,
          event.jobName
        ];

        return _.filter(names).join('.');
      };
    }
  };
}).
directive('magpieSecret', function() {
  return {
    restrict: 'E',
    scope: {
      description: '=',
      userPermissions: '=?'
    },
    templateUrl: 'components/magpie-display/security/secret.html',
    controller: function($scope) {
      $scope.secret = $scope.description.secret;
      $scope.lineage = $scope.description.lineage;
      $scope.userPermissions = $scope.description.userPermissions;
    }
  };
}).
directive('magpieIdentityProvider', function() {
  return {
    restrict: 'E',
    scope: {
      description: '=?',
      organization: '=?'
    },
    templateUrl: 'components/magpie-display/security/identity-provider.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.provider = $scope.description.provider;
        $scope.organization = $scope.description.organization;
      }
    }
  };
});



// WEBPACK FOOTER //
// ./src/components/magpie-display/security/magpie-security.js